export default [
    {
        path: '/prerequisite/expense-types',

        name: 'Expense Types',

        component: () => import('@/views/prerequisite/expense-types'),
    },
];